import { useMemo } from 'react';
import { Sponsor } from '@repo/types';
import { useSponsorsQuery } from '@data/sponsors/useSponsorsQuery';

export type UseFilteredSponsorsArgs = {
  showAllSponsors: boolean;
  sponsorIds?: string[];
};

/**
 * Fetches the tenant's sponsors and narrows them to either all sponsors or the
 * hand-picked `sponsorIds`. Shared by the Sponsors Grid and Sponsors Carousel.
 */
export const useFilteredSponsors = ({ showAllSponsors, sponsorIds }: UseFilteredSponsorsArgs) => {
  const { data, isLoading, error } = useSponsorsQuery();

  const sponsors = useMemo<Sponsor[] | null>(() => {
    if (!data) {
      return null;
    }

    return showAllSponsors ? data : data.filter((sponsor) => sponsorIds?.includes(sponsor.id));
  }, [showAllSponsors, sponsorIds, data]);

  return { sponsors, isLoading, error };
};
